import "./DappTestimonial.css";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import button from "../decentassets/button.png";
import symbol from "../decentassets/symbol.png";
import f1 from "../decentassets/pic1.png";
import f2 from "../decentassets/pic2.png";
import f3 from "../decentassets/pic3.png";
import f4 from "../decentassets/pic4.png";

const DappTestimonial = () => {
  const data = [
     {
       id: 1,
       image: f1,
       name: "Manish Guptar",
       position: "— Delhi, India",
       feedback:
         "User adoption improved after launch because the interface was simple despite complex on-chain logic. The balance between UX and decentralization was well handled.",
     },
     {
       id: 2,
       image: f2,
       name: "Sandeep Nair",
       position: "– Dhaka, Bangladesh",
       feedback:
         "Timelines were realistic, communication was clear, and delivery matched what was promised. For us, that reliability mattered more than anything else.",
     },
     {
       id: 3,
       image: f3,
       name: "Nikhil Jain",
       position: "– San Bernardino, California",
       feedback:
         "Our platform needed to integrate different blockchain components, and the execution was best. The system has been running smoothly post-launch.",
     },
     {
       id: 4,
       image: f4,
       name: "Rahul Mehta",
       position: "— Alabama, United States",
       feedback:
         "Technical decisions were clear, and the scalable architecture delivered a stable, compliant dApp built for long-term growth.",
     },
   ];
  const settings = {
    dots: false,
    arrows: true,
    autoplay: true,
    infinite: true,
    speed: 900,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplaySpeed: 3000,
    cssEase: "ease-in-out",
    nextArrow: <img src={button} alt="Next" className="nextArrow" />,
    prevArrow: <img src={button} alt="Previous" className="prevArrow" />,
    responsive: [
      {
        breakpoint: 1150,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          infinite: true,
          dots: false,
        },
      },
      {
        breakpoint: 700,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          initialSlide: 1,
        },
      },
    ],
  };
  return (
    <div id='dapp-testimonial' className="progressive-wrapper">
       <div className="container-main">
            <h2 className="heading">
         Words From Our Clients
            </h2>
            {/* <p className="subHeading">
            We build trust through proven client experiences, delivering reliable CRM solutions that drive measurable results and long-term business growth.
            </p> */}
            <Slider {...settings}>
                {data.map((item) => {
                    return (
                        <div className="fwrapper" key={item.id}>
                            <div className="fbox">
                                <div className="symbolbox">
                                    <img src={symbol} alt="" className="symbolimage" />
                                </div>
                                <div className="fcontent">
                                    <p>{item.feedback}</p>
                                    <div className="personinfo">
                                        <h3>{item.name}</h3>
                                        <h4>{item.position}</h4>
                                    </div>
                                </div>
                                <div className="profilebox">
                                    <img src={item.image} alt="" className="profileimage" />
                                </div>
                            </div>
                        </div>
                    );
                })}
            </Slider>
    </div>
</div>
  );
};

export default DappTestimonial;
